"use client";

import styles from '../css/components/RadioButton.module.css';
import PropTypes from "prop-types";
import clsx from "clsx"; // helps merge class names

export default function RadioButton({ name, options, selectedValue, onChange, direction = "row", className = "" }) {
  return (
    <div
      className={clsx(
        styles.radioGroup,
        direction === "column" && styles.radioGroupColumn,
        className
      )}
    >
      {options.map((option) => (
        <label key={option.value} className={styles.radioLabel}>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
            className={styles.radioInput}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(["row", "column"]), // new
  className: PropTypes.string, // optional custom classes
};
